// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SqlQueryComponent_drawer__LKsBZ {
    width: 250px;
    padding: 15px;
    font-size: 14px;
    word-wrap: break-word;
}
.SqlQueryComponent_drawer__LKsBZ > div  {
    min-height: 560px;
    border: 1px solid rgba(0, 0, 0, 0.26);
    padding: 10px;
    border-radius: 5px;
}
.SqlQueryComponent_copyBtn__gDmtH > button{
    border: 1px solid;
    border-radius: 18px;
    padding: 5px 10px;
    font-size: 14px;
    background-color: #005cbc;
    color: #fff;
}
.SqlQueryComponent_copyBtn__gDmtH {
    text-align: right;
    margin: 0px 15px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ChatBotComponent/AdditionalOptions/SqlQueryComponent.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":[".drawer {\n    width: 250px;\n    padding: 15px;\n    font-size: 14px;\n    word-wrap: break-word;\n}\n.drawer > div  {\n    min-height: 560px;\n    border: 1px solid rgba(0, 0, 0, 0.26);\n    padding: 10px;\n    border-radius: 5px;\n}\n.copyBtn > button{\n    border: 1px solid;\n    border-radius: 18px;\n    padding: 5px 10px;\n    font-size: 14px;\n    background-color: #005cbc;\n    color: #fff;\n}\n.copyBtn {\n    text-align: right;\n    margin: 0px 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer": `SqlQueryComponent_drawer__LKsBZ`,
	"copyBtn": `SqlQueryComponent_copyBtn__gDmtH`
};
export default ___CSS_LOADER_EXPORT___;
